<template>
    <div v-if="serialModel.showTimer">
        <div class="grid grid-cols-2" v-if="!isTimeExpired">
            <div class="text-14 text-im-gray-767676 text-right">
                {{lbl.iimmpact.serial.expire_in}}
            </div>
            <div class="text-14 text-im-red-ff5757 pl-1">
                {{displayTime}}
            </div>
             
        </div>
        <div v-else class="text-14 text-im-gray-767676 text-center">
            {{lbl.iimmpact.serial.code_expired}}
        </div>
    </div>
</template>
<script>
import TimerHelper from '@/helper/TimerHelper.js';
//feature
import { useLocale } from "@/feature/LocaleFeature"

export default {
    setup: function() {
        const { lbl } = useLocale()
        return {
            lbl,
        }
    },
    name: "SerialTimer",
    props: {
        serialModel: Object,
    },
    data: function () {
        return {
            timer: new TimerHelper(),
            displayTime: "",
            isTimeExpired: false,
        };
    },
    created: function () {
        this.initial();
    },
    beforeUnmount: function() {
        if (this.timer.interval) {
            this.timer.stopTimer();
        }
    },
    methods: {
        initial: function () {
            if (this.timer.interval) {
                this.timer.stopTimer();
            }

            this.timer.initialTimer(this.serialModel.expireIn);
            if (this.serialModel.showTimer) {
                this.isTimeExpired = false;
                this.timer.runTimer((display) => {
                    this.displayTime = display;
                }, () => {
                    this.isTimeExpired = true;
                    this.serialExpired();
                });
            }
        },
        serialExpired: function () {
            this.$emit("onSerialExpired");
        },
    }
}
</script>
<style lang="scss" scoped>

</style>
